import React from 'react';

import tutorialVideo from 'pages/Students/Assignments/Detail/assets/camera-orientation-video.mp4';

import styles from './styles.module.scss';

const TutorialVideo = ({ onClose }) => {
  return (
    <div className={styles.videoContainer}>
      <video autoPlay muted playsInline onClick={onClose} onEnded={onClose}>
        <source src={tutorialVideo} type="video/mp4" />
      </video>
      <button className={styles.skipBtn} onClick={onClose}>
        Skip
      </button>
    </div>
  );
};

export default TutorialVideo;
